import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Bandratopunecab() {



const cardData = {
  keyword: " Bandra to Pune Cabs ",

headingDescription: "Velocity Cab provides reliable and comfortable Bandra to Pune cab services, ensuring a smooth and hassle-free journey for business trips, airport transfers, family outings, and leisure travel. Our professional drivers, well-maintained vehicles, and punctual pickups make traveling from Bandra to Pune convenient and stress-free. We offer flexible booking options including one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, and luxury cars suitable for solo travelers, families, and corporate clients. With easy online booking and 24/7 customer support, Velocity Cab is the trusted choice for Bandra to Pune cab travel.",

topPlaces: [
  
  {
    title: "Dagdusheth Halwai Ganpati Temple",
    description: "Dagdusheth Halwai Ganpati Temple is one of the most revered temples in Pune dedicated to Lord Ganesha. Visitors traveling from Bandra by cab frequently stop here to seek blessings and experience the spiritual atmosphere."
  },
  {
    title: "Pataleshwar Cave Temple",
    description: "Pataleshwar Cave Temple is an ancient rock-cut temple dedicated to Lord Shiva located in the heart of Pune. Travelers using a Bandra to Pune cab can visit this peaceful historical site known for its unique architecture."
  },
  {
    title: "Raja Dinkar Kelkar Museum",
    description: "Raja Dinkar Kelkar Museum houses a remarkable collection of Indian artifacts including sculptures, musical instruments, and decorative items. Visitors from Bandra can explore Pune’s rich cultural heritage through this museum."
  },
  {
    title: "Shaniwar Wada",
    description: "Shaniwar Wada is a historic fortification in Pune that once served as the seat of the Peshwas of the Maratha Empire. Travelers using a Bandra to Pune cab often visit this landmark to explore its grand gates, historical ruins, and cultural significance."
  },
  {
    title: "Aga Khan Palace",
    description: "Aga Khan Palace is one of Pune’s most important historical landmarks associated with India’s freedom movement and Mahatma Gandhi. Visitors traveling from Bandra by cab can explore its elegant architecture, peaceful gardens, and museum."
  },
  {
    title: "Sinhagad Fort",
    description: "Sinhagad Fort is a famous hill fortress located on the outskirts of Pune, known for its scenic views and Maratha history. Travelers arriving from Bandra by cab often include this destination for trekking and enjoying breathtaking landscapes."
  },
  {
    title: "Parvati Hill Temple",
    description: "Parvati Hill Temple is one of the oldest heritage sites in Pune offering panoramic views of the city. Travelers arriving from Bandra by cab often climb the hill to enjoy scenic beauty and visit the historic temples."
  },
  {
    title: "Khadakwasla Dam",
    description: "Khadakwasla Dam is a popular getaway near Pune known for its serene water views and surrounding hills. Travelers from Bandra often visit this relaxing spot for photography and peaceful sunsets."
  },
  {
    title: "Pune Okayama Friendship Garden",
    description: "Pune Okayama Friendship Garden, also called Pu La Deshpande Garden, is a beautifully designed Japanese-style garden. Visitors traveling from Bandra by cab can enjoy its calm atmosphere, walking paths, and lush greenery."
  },
  {
    title: "Lal Mahal",
    description: "Lal Mahal is a historic palace associated with the childhood of Chhatrapati Shivaji Maharaj. Travelers using a Bandra to Pune cab can visit this important landmark to learn about Pune’s rich Maratha history."
  }
],



services: [
{
name: "Bandra Terminus to Pune Cab",
description: "Bandra Terminus to Pune cab service provides reliable transportation between Bandra Terminus railway station in Mumbai and Pune city. Comfortable vehicles such as sedan, Ertiga, and Innova ensure smooth travel via the Mumbai–Pune Expressway. Professional drivers offer punctual pickup services from Bandra Terminus and nearby areas."
},
{
name: "Bandra Terminus to Pune Taxi Fare",
description: "Bandra Terminus to Pune taxi fare service provides transparent pricing for travelers heading from Mumbai to Pune. Vehicles such as sedan, Ertiga, and Innova are available depending on comfort needs."
},
{
name: "Bandra to Pune Taxi",
description: "Bandra to Pune taxi service offers convenient intercity transportation between Mumbai’s Bandra area and Pune city. Comfortable vehicles and experienced drivers ensure smooth expressway journeys."
},
{
name: "Bandra to Pune Taxi Fare",
description: "Bandra to Pune taxi fare service provides affordable pricing options for passengers traveling between Bandra in Mumbai and Pune city."
},
{
name: "Bandra to Pune One Way Taxi",
description: "Bandra to Pune one way taxi service offers convenient single-trip transportation without return charges. Comfortable vehicles ensure safe and smooth expressway travel."
},
{
name: "Taxi from Bandra Terminus to Pune",
description: "Taxi from Bandra Terminus to Pune provides dependable transportation between Mumbai and Pune. Comfortable vehicles ensure relaxed highway journeys."
},
{
name: "Bandra to Pune Drop Taxi",
description: "Bandra to Pune drop taxi service offers convenient drop-only transportation between Bandra and Pune with comfortable vehicles."
},
{
name: "Bandra to Pune Innova Taxi Fare",
description: "Bandra to Pune Innova taxi fare service provides pricing for passengers traveling in premium Innova vehicles offering spacious seating and comfortable highway travel."
},
{
name: "Bandra to Pune Ertiga Car Fare",
description: "Bandra to Pune Ertiga car fare service provides economical travel options for passengers using comfortable 7-seater Ertiga vehicles."
},
{
name: "Bandra to Pune Round Trip Cab Booking",
description: "Bandra to Pune round trip cab booking provides convenient two-way transportation between Mumbai and Pune for family trips, business travel, and tourism."
},
{
name: "Mumbai to Pune Taxi Fare",
description: "Mumbai to Pune taxi fare service provides transparent pricing details for passengers traveling between Mumbai and Pune city."
},
{
name: "Mumbai to Pune Car Rental",
description: "Mumbai to Pune car rental service offers reliable vehicle hire with drivers for comfortable intercity travel between the two cities."
},
{
name: "Bandra Kurla Complex to Pune Cab",
description: "Bandra Kurla Complex to Pune cab service provides convenient transportation between BKC business district and Pune city."
},
{
name: "Bandra Kurla Complex to Pune Cab Fare",
description: "Bandra Kurla Complex to Pune cab fare service provides clear pricing options for passengers traveling between BKC and Pune."
},
{
name: "Best Cab Service Mumbai to Pune",
description: "Best cab service Mumbai to Pune offers reliable intercity transportation with comfortable vehicles and experienced drivers ensuring safe highway travel."
},
{
name: "Cab Service in Bandra Mumbai",
description: "Cab service in Bandra Mumbai provides dependable transportation for city rides, airport transfers, and outstation journeys across Mumbai."
},
{
name: "Bandra to Pune Innova Crysta Cab",
description: "Bandra to Pune Innova Crysta cab service offers luxury SUV transportation with spacious seating and smooth highway travel."
},
{
name: "Bandra to Pune Ertiga Cab",
description: "Bandra to Pune Ertiga cab service provides comfortable 7-seater SUV transportation suitable for families and group travel."
},
{
name: "Bandra to Pimpri Chinchwad Cab",
description: "Bandra to Pimpri Chinchwad cab service provides convenient transportation between Mumbai and PCMC area in Pune."
},
{
name: "Bandra to Outstation Cab Service",
description: "Bandra to outstation cab service provides reliable long-distance transportation from Bandra to cities like Pune, Nashik, and Lonavala."
},
{
name: "Bandra Terminus Taxi Service for Outstation",
description: "Bandra Terminus taxi service for outstation provides dependable transportation for passengers traveling from Bandra Terminus to nearby cities including Pune."
},
{
name: "Bandra to Pune Cab",
description: "Bandra to Pune cab service offers reliable intercity transportation between Mumbai and Pune with comfortable vehicles."
},
{
name: "Bandra to Pune Taxi",
description: "Bandra to Pune taxi service provides safe and convenient transportation for passengers traveling between the two cities."
},
{
name: "Bandra to Pune Cab Service",
description: "Bandra to Pune cab service provides dependable transportation with professional drivers and comfortable vehicles."
},
{
name: "Bandra to Pune Taxi Service",
description: "Bandra to Pune taxi service offers convenient highway travel between Mumbai and Pune with reliable vehicles."
},
{
name: "Bandra to Pune Cab Booking",
description: "Bandra to Pune cab booking allows passengers to easily reserve taxis for intercity travel between Mumbai and Pune."
},
{
name: "Cab from Bandra to Pune",
description: "Cab from Bandra to Pune service offers comfortable intercity transportation with experienced drivers ensuring safe highway journeys."
}
],

tableData: [
["Bandra Terminus to Pune Cab","Bandra Terminus to Pune Taxi Fare"],
["Bandra to Pune Taxi","Bandra to Pune Taxi Fare"],
["Bandra to Pune One Way Taxi","Taxi from Bandra Terminus to Pune"],
["Bandra to Pune Drop Taxi","Bandra to Pune Innova Taxi Fare"],
["Bandra to Pune Ertiga Car Fare","Bandra to Pune Round Trip Cab Booking"],
["Mumbai to Pune Taxi Fare","Mumbai to Pune Car Rental"],
["Bandra Kurla Complex to Pune Cab","Bandra Kurla Complex to Pune Cab Fare"],
["Best Cab Service Mumbai to Pune","Cab Service in Bandra Mumbai"],
["Bandra to Pune Innova Crysta Cab","Bandra to Pune Ertiga Cab"],
["Bandra to Pimpri Chinchwad Cab","Bandra to Outstation Cab Service"],
["Bandra Terminus Taxi Service for Outstation","Bandra to Pune Cab"],
["Bandra to Pune Taxi","Bandra to Pune Cab Service"],
["Bandra to Pune Taxi Service","Bandra to Pune Cab Booking"],
["Cab from Bandra to Pune","Bandra Terminus to Pune Cab"]
],





whychoose: [
  {
    WhyChooseheading: "Experienced Expressway Drivers",
    WhyChoosedescription: "Velocity Cabs provides experienced drivers who regularly travel from Bandra to Pune via the Mumbai Pune Expressway. Their knowledge of highway routes and traffic conditions ensures safe and timely intercity travel."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Velocity Cabs offers transparent and affordable pricing for Bandra to Pune cab bookings. Customers receive clear fare details including toll charges and driver allowance before confirming the ride."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "Our Bandra to Pune cab service operates 24 hours a day. Whether you need an early morning ride, airport transfer, or late night travel, Velocity Cabs ensures reliable transportation anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in the Velocity Cabs fleet are fully air-conditioned, well maintained, and regularly cleaned to provide passengers with a comfortable long-distance travel experience."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Velocity Cabs offers flexible travel options including one-way cab service, round-trip bookings, airport transfers, and customized travel plans from Bandra to Pune."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Velocity Cabs offers a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers suitable for individuals, families, and corporate travelers."
  },
  {
    WhyChooseheading: "Doorstep Pickup in Bandra",
    WhyChoosedescription: "We provide convenient pickup from homes, hotels, offices, railway stations, and residential areas across Bandra including Bandra West, Bandra East, BKC, and nearby locations."
  },
  {
    WhyChooseheading: "Trusted Intercity Cab Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many travelers for Bandra to Pune cab bookings thanks to punctual drivers, comfortable vehicles, and professional intercity travel service."
  }
]
};

const faqData = [
  { question: "Do you provide Bandra to Pune cab service?", answer: "Yes, Velocity Cabs provides reliable cab services from Bandra to Pune with professional drivers and comfortable vehicles." },
  { question: "How far is Bandra from Pune?", answer: "The road distance between Bandra and Pune is approximately 150 km and the journey usually takes about 3 to 4 hours depending on traffic." },
  { question: "Is Bandra to Pune cab service available 24 hours?", answer: "Yes, our cab service operates 24/7 to match customer travel schedules." },
  { question: "Which vehicles are available for Bandra to Pune travel?", answer: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers." },
  { question: "Can I book a one-way cab from Bandra to Pune?", answer: "Yes, we provide both one-way and round-trip cab services between Bandra and Pune." },
  { question: "Do you provide pickup from homes and hotels?", answer: "Yes, our drivers provide doorstep pickup from homes, hotels, offices, and residential areas across Bandra." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Velocity Cabs are fully air-conditioned for comfortable long-distance travel." },
  { question: "Can I book the cab online?", answer: "Yes, customers can easily book Bandra to Pune cab services online or through phone booking." },
  { question: "Do you provide drop service to Pune Airport or railway station?", answer: "Yes, Velocity Cabs provides drop services to Pune Airport, railway stations, and major locations across Pune." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sameer Kulkarni",
    feedback:
      "My Bandra to Pune cab ride with Velocity Cabs was comfortable and hassle-free. The driver was punctual, the vehicle was spotless, and the journey was completed safely.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Shweta Rao",
    feedback:
      "I selected Velocity Cabs for my Bandra to Pune travel, and the service exceeded my expectations. The cab was well-maintained, the driver was courteous, and the entire trip was pleasant.",
    rating: 5
  }
];


































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];














const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bandra to Pune Cab Service | Velocity Cabs",
  "description": "Velocity Cabs provides reliable Bandra to Pune cab service with affordable fares and professional drivers. Book one way and round trip taxis including Innova, Innova Crysta, Ertiga, and Sedan cabs for airport transfers, city-to-city travel, and corporate trips. Enjoy safe, comfortable, and punctual rides with easy online booking from Bandra to Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Velocity Cabs"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.velocitycabs.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};




  return (
    <div>
      
<Helmet>
  <title>Bandra to Pune Cab | Call +91 9136271336 | Velocity Cabs</title>
  <meta 
    name="description" 
    content="Book Bandra to Pune cab with Velocity Cabs. Affordable one way & round trip taxis including Innova, Innova Crysta, Ertiga & Sedan for airport transfers, city-to-city travel & corporate trips." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/35.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Bandratopunecab;